import { render, staticRenderFns } from "./OrgApprovals.vue?vue&type=template&id=ec1b54a4"
import script from "./OrgApprovals.vue?vue&type=script&lang=js"
export * from "./OrgApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec1b54a4')) {
      api.createRecord('ec1b54a4', component.options)
    } else {
      api.reload('ec1b54a4', component.options)
    }
    module.hot.accept("./OrgApprovals.vue?vue&type=template&id=ec1b54a4", function () {
      api.rerender('ec1b54a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/OrgApprovals.vue"
export default component.exports